// extracted by mini-css-extract-plugin
export var numpadContainer = "_on-1";
export var phoneButton = "_on-0";